import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from '@ifit/rapport-webview';
import cx from 'classnames';
import I18nType from '../../../../shared/i18n-prop-type';
import rapportPackage from '../rapport-web.json'

import './index.scss';

export const VerticalDivide = ({ i18n, text, endSpacing }) => (
  <div
    className={cx('vertical-divide', {
      'end-spacing': endSpacing,
    })}
  >
    <div className="line"></div>
    <div className="word">
      {text ||
        i18n._translate('My Favorites', {
          context:
            'Text that separates continued Series and Favorited workouts',
        })}
    </div>
  </div>
);

VerticalDivide.propTypes = {
  text: PropTypes.string,
  i18n: I18nType,
  endSpacing: PropTypes.bool,
};

export default withTranslation(rapportPackage)(VerticalDivide);
